export default "__VITE_ASSET__BMS0rWJQ__"